import React from 'react';
import { QuestionGroupViewPropTypes } from '../../utils';

const Base = (props) => {
  const { renderAllQuestions } = props;

  return <div>{renderAllQuestions()}</div>;
};

Base.propTypes = QuestionGroupViewPropTypes;

export default Base;
